import { RefObject, useEffect } from 'react'

const useOuterClick = (ref: RefObject<HTMLElement>, callback: (e: MouseEvent) => void) => {
  useEffect(() => {
    const handleClick = (e: MouseEvent) => {
      const clickedElement = e.target as Element
      const clickedElementRect = clickedElement.getBoundingClientRect()

      // if element is not visible then it doesn't count as outer click
      if (clickedElementRect.width === 0 && clickedElementRect.height === 0) return

      if (ref.current && callback && !ref.current.contains(e.target as Node)) {
        callback(e)
      }
    }
    document.addEventListener('click', handleClick)

    return () => document.removeEventListener('click', handleClick)
  }, [callback, ref])
}

export default useOuterClick
